(function () {
  function setRem() {
    const doc = document.documentElement
    const width = doc.getBoundingClientRect().width
    if (width > 750) {
      doc.style.fontSize = '100px'
    } else {
      doc.style.fontSize = width / 7.5 + 'px'
    }
  }
  setRem()
  window.addEventListener('resize', setRem)
})()
